import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'mlp-ng-button-nav',
    templateUrl: './button-nav.component.html',
    styleUrls: ['./button-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ButtonNavSharedComponent implements OnInit {
    @Input() side: 'left' | 'right';

    ngOnInit(): void {
        if (!this.side) {
            throw new Error('Attribute side is required');
        }
    }

}
